import React from 'react'
import PropTypes from 'prop-types'
import Layout from '../components/layout'
import StructuredData from "../components/structured-data";
import SeoTags from '../components/seo-tags'
import { withRouter } from 'react-router-dom';
import Breadcrumbs from "../components/breadcrumbs/breadcrumbs";
import Jumbotron from "../components/jumbotron/jumbotron";

const AboutPage = ({ data, location }) => {
  const { markdownRemark: post } = data
  const title = post.frontmatter.title
  const seo = post.frontmatter.seo
  const html = post.html

  return (
    <Layout>
      <StructuredData isReview={false} isBreadcrumbs={true} title={title} pagePath={location.pathname} />
      <SeoTags
        title={`${seo.title}`}
        description={`${seo.description}`}
      />
      <Jumbotron
        isIndexPage
        title={title}
        subheading="my story & values"
        image="/img/deposit_suv-on-wild-mountain-road.jpg"
        alt="Autokwix - history and my values"
      />
      <Breadcrumbs currentPage={title} />
      <div className="about">
        <div className="about__wrapper">
          <div className="about__text" dangerouslySetInnerHTML={{ __html: html }} />
        </div>
      </div>
    </Layout>
  )
}

AboutPage.propTypes = {
  data: PropTypes.object.isRequired,
}

export default withRouter(AboutPage);

export const aboutPageQuery = graphql`
  query AboutPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
        seo {
          title
          description
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/about-page.js